var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "consulta-instalaciones-conecta__base" }, [
    _c(
      "div",
      { staticClass: "flex sm12 m12" },
      [
        _c(
          "FormFieldsContainer",
          [
            _c(
              "v-flex",
              {
                attrs: { sm12: "", md12: "", layout: "", wrap: "", "my-4": "" }
              },
              [
                _c(
                  "v-flex",
                  {
                    attrs: { xs12: "", sm8: "", md7: "", layout: "", wrap: "" }
                  },
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm12: "", md12: "", layout: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs6: "", sm5: "", md5: "", "mr-3": "" } },
                          [
                            _c("DatePicker", {
                              attrs: { label: "Fecha Inicio", max: _vm.today },
                              model: {
                                value: _vm.objectParam.start_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.objectParam, "start_date", $$v)
                                },
                                expression: "objectParam.start_date"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { xs6: "", sm5: "", md5: "", "mr-3": "" } },
                          [
                            _c("DatePicker", {
                              attrs: { label: "Fecha Fin", max: _vm.today },
                              model: {
                                value: _vm.objectParam.end_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.objectParam, "end_date", $$v)
                                },
                                expression: "objectParam.end_date"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm12: "", md12: "", layout: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm4: "", m4: "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                label: "Orden de Servicio",
                                items: _vm.filter.orden_servicio,
                                "item-text": "altaserorden_numero",
                                "item-value": "altasernumero",
                                clearable: "",
                                "prepend-icon": "home_repair_service"
                              },
                              on: { change: _vm.handleFilters },
                              model: {
                                value: _vm.objectParam.altasernumero,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.objectParam,
                                    "altasernumero",
                                    $$v
                                  )
                                },
                                expression: "objectParam.altasernumero"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm4: "", m4: "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                label: "Coordinador",
                                items: _vm.filter.coordinadores,
                                "item-text": "coorname",
                                "item-value": "coorid",
                                clearable: "",
                                "prepend-icon": "person"
                              },
                              on: { change: _vm.handleFilters },
                              model: {
                                value: _vm.objectParam.coorid,
                                callback: function($$v) {
                                  _vm.$set(_vm.objectParam, "coorid", $$v)
                                },
                                expression: "objectParam.coorid"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm4: "", m4: "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                label: "Tipo de Equipo",
                                items: _vm.filter.equipos,
                                "item-text": "tipoeqname",
                                "item-value": "tipoeqid",
                                clearable: "",
                                "prepend-icon": "home_repair_service"
                              },
                              on: { change: _vm.handleFilters },
                              model: {
                                value: _vm.objectParam.tipoeqid,
                                callback: function($$v) {
                                  _vm.$set(_vm.objectParam, "tipoeqid", $$v)
                                },
                                expression: "objectParam.tipoeqid"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-flex",
                      { attrs: { sm12: "", md12: "", layout: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm4: "", m4: "" } },
                          [
                            _c("v-text-field", {
                              staticStyle: { "margin-right": "5px" },
                              attrs: {
                                label: "Buscar Número de Serie...",
                                clearable: "",
                                "prepend-icon": "search"
                              },
                              on: { input: _vm.handleFilters },
                              model: {
                                value: _vm.objectParam.serienumero,
                                callback: function($$v) {
                                  _vm.$set(_vm.objectParam, "serienumero", $$v)
                                },
                                expression: "objectParam.serienumero"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm4: "", m4: "", "mr-3": "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                label: "Cliente Instalado",
                                items: _vm.filter.cliente_instalado,
                                "item-text": "instalacion_razon_social",
                                "item-value": "clienterut",
                                clearable: "",
                                "prepend-icon": "person"
                              },
                              on: { change: _vm.handleFilters },
                              model: {
                                value: _vm.objectParam.clienterut,
                                callback: function($$v) {
                                  _vm.$set(_vm.objectParam, "clienterut", $$v)
                                },
                                expression: "objectParam.clienterut"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm4: "", m4: "" } },
                          [
                            _c("v-checkbox", {
                              attrs: {
                                label:
                                  "Cliente Preparado Distinto de Cliente Instalado"
                              },
                              on: { change: _vm.handleFilters },
                              model: {
                                value: _vm.objectParam.otro_cliente_preparacion,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.objectParam,
                                    "otro_cliente_preparacion",
                                    $$v
                                  )
                                },
                                expression:
                                  "objectParam.otro_cliente_preparacion"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "v-flex",
                  {
                    attrs: {
                      xs12: "",
                      sm4: "",
                      md4: "",
                      layout: "",
                      "mt-2": ""
                    }
                  },
                  [
                    _c(
                      "v-btn",
                      { on: { click: _vm.handleSearchFilter } },
                      [
                        _c("v-icon", { attrs: { color: "#27488e" } }, [
                          _vm._v("search")
                        ]),
                        _vm._v("Filtrar\n          ")
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      { on: { click: _vm.handleClearFilter } },
                      [
                        _c("v-icon", { attrs: { color: "#27488e" } }, [
                          _vm._v("clear")
                        ]),
                        _vm._v("Limpiar\n          ")
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        attrs: { flat: "", small: "", color: "primary" },
                        on: { click: _vm.getCSV }
                      },
                      [
                        _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                          _vm._v("cloud_download")
                        ]),
                        _vm._v("  \n            "),
                        _c("span", { staticClass: "importExportBtnTexto" }, [
                          _vm._v("Exportar"),
                          _c("br"),
                          _vm._v("CSV")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-flex",
          { attrs: { xs12: "", sm12: "", md12: "" } },
          [
            _c("GridComponent", {
              staticClass: "ag-theme-material",
              attrs: { "grid-options": _vm.gridOptions }
            })
          ],
          1
        ),
        _vm.showPopUpReport
          ? _c("PopUpGeneratedReports", {
              attrs: { text: _vm.msgReport },
              on: { cerrar: _vm.handleCloseReport }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }